// Note: 'slick-active' is added by default by slick
const COMPLETED_CLASS = 'slick-completed';
const WAITING_CLASS = 'slick-waiting';

function initializeClasses({ $, slickPages }) {
  slickPages.removeClass(COMPLETED_CLASS);
  slickPages.addClass(WAITING_CLASS);
  $(slickPages.get(0)).removeClass(WAITING_CLASS);
}

function sentenceSlider($) {
  const sentenceSliders = $('.sentence-slider__slider');

  sentenceSliders.each((index, s) => {
    const sentenceSlider = $(s);
    const module = sentenceSlider.parents('.sentence-slider');

    if (typeof slickAnimate === "function") {
      slickAnimate(sentenceSlider);
    }
  
    const slickConfig = {
      infinite: true,
      fade: true,
      dots: true,
      arrows: true,
      speed: 500,
      slidesToShow: 1,
      adaptiveHeight: false,
      autoplay: true,
      nextArrow: module.find('.sentence-slider__arrow--next'),
      prevArrow: module.find('.sentence-slider__arrow--prev'),
      appendDots: module.find('.sentence-slider__pagination'),
    };
  
    sentenceSlider.slick(slickConfig);
    const slickPages = module.find('.sentence-slider__pagination li');
    initializeClasses({ $, slickPages });
  
    sentenceSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      if (currentSlide >= slickPages.length - 1) {
        initializeClasses({ $, slickPages });
      } else {
        $(slickPages.get(currentSlide)).addClass(COMPLETED_CLASS);
      }
      $(slickPages.get(currentSlide + 1)).removeClass(WAITING_CLASS);
    });
  });
}

// Inits
if (typeof jQuery !== 'undefined') jQuery(document).ready(function ($) {
  sentenceSlider($);
});
